import { useQuery, UseQueryResult } from '@tanstack/react-query';

import {
	getMobileScansList,
	IGetMobileScansListParams,
	IMobileScansListResult
} from 'src/apps/mobile-common/services/mobile-scans-list';
import { MOBILE_SCANS_LIST } from 'src/common/providers/reactQueryProvider/QueryKeys';

export const useMobileScansListQuery = (
	params: IGetMobileScansListParams
): UseQueryResult<IMobileScansListResult> =>
	useQuery([MOBILE_SCANS_LIST, params], () => getMobileScansList(params), {
		enabled: Boolean(params.runId)
	});
